import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, HostListener, Inject, OnDestroy, PLATFORM_ID, Renderer2 } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute,Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { DataLayerService } from '../../../shared/services/gtm-service/data-layer.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { SchemaService } from '../../../shared/services/schema.service';
import { SkeletonService } from '../../../shared/services/skeleton.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { SubcatService } from '../../../shared/services/subcat.service';
import { CarousalPageComponent } from '../../../shared/components/carousal-page/carousal-page.component';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { SolarLoanComponent } from "../solar-loan/solar-loan.component";
import { GemComponent } from "../gem/gem.component";
import { SolarDesignComponent } from "../solar-design/solar-design.component";
import { FaqPageComponent } from "../faq-page/faq-page.component";
import { TruncatePipe } from '../../../shared/pipes/truncate.pipe';
import { ResponsiveUIService } from '../../../services/responsive-ui.service';

@Component({
  selector: 'app-inbt-categorypage',
  standalone: true,
  imports: [CommonModule, CarousalPageComponent, RouterModule, TruncatePipe, CarouselModule, SolarLoanComponent, GemComponent, SolarDesignComponent, FaqPageComponent],
  templateUrl: './inbt-categorypage.component.html',
  styleUrl: './inbt-categorypage.component.scss'
})
export class InbtCategorypageComponent implements OnDestroy, AfterViewInit {
  environment: any = environment;
  subCatGuid: any;
  subcatData: any;
  pdfPages: any;
  webBannerList: any = [];
  bannerlist: any = [];
  mobileBannerList: any = [];
  selectedTechnologyData: any;
  productCarousalData!: any[];
  sub: Subscription = new Subscription()
  smallWebBannerList: any = [];
  smallMobileBannerList: any = [];
  showVideoSection: boolean = false;
  categoryData: any;
  landingPageName!: string;
  autoplay: boolean = true;
  faqlist: any;
  medialist: any;
  script: any;
  actualSchemaValue: any;
  structuredData!: SafeHtml;
  responsiveSub: Subscription = new Subscription();
  deviceStatus: any;
  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    mouseDrag: true,
    touchDrag: true,
    dots: true,
    navSpeed: 600,
    nav: false,
    navText: ['', ''],
    stagePadding: 0,
    center: true,
    margin: 0,
    responsive: {
      0: {
        items: 1
      }
    },
  };
  imgLoaded: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    public utils: UtilsService, public analyticsService: AnalyticsService,
    private subcatSvc: SubcatService, private route: ActivatedRoute,
    private router: Router, private metaSvc: MetaMgmtService,
    private _dataLayerService: DataLayerService, private schemaService: SchemaService,
    public skeletonService: SkeletonService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private sanitizer: DomSanitizer, private responsivSrv: ResponsiveUIService,

  ) {
    this.responsiveSub = this.responsivSrv.getDeviceStatus().subscribe((res: any) => {
      if (res) {
        this.deviceStatus = res
      } else { }
    })
    this.utils.showHeaderFooter.next(true);
    this.sub.add(this.route.params.subscribe((params: any) => {
      this.resetAll();
      this.subCatGuid = params['guid'] ? params['guid'] : '';
      this.landingPageName = params['subCatName'] ? params['subCatName'] : '';
      const validLandingPages = ['solar-loan', 'gem', 'solar-design'];
      if (!validLandingPages.includes(this.landingPageName)) {
        this.inIt();
      }
    }))
  }


  handleSlideChange(event: any, type: string) {
    let currentSlideData: any;
    let slideList: any[];
    if (this.autoplay) {
      if (type === 'web') {
        currentSlideData = this.webBannerList[event.startPosition];
        slideList = this.webBannerList;
      } else if (type === 'mob') {
        currentSlideData = this.mobileBannerList[event.startPosition];
        slideList = this.mobileBannerList;
      }

      currentSlideData.creativeSlot = event.startPosition + 1;

      this.triggerPromotionEventsIfListExists([currentSlideData]);
    }
  }


  inIt() {
    if (this.subCatGuid || this.landingPageName) {
      this.utils.showLoading();
      this.sub.add(this.subcatSvc.getSubCatDataByGuid(this.subCatGuid, this.landingPageName, this.subCatGuid ? true : false).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.utils.hideLoading();
            this.subcatData = res;
            this.metaSvc.updateMetaTags(res.metaInfoResponse);
            if (res.commonSectionDetail != "" && res.commonSectionDetail != null && res.commonSectionDetail != undefined) {
              this.faqlist = res.commonSectionDetail.questionAnswerList;
              this.medialist = res.commonSectionDetail.mediaList;
            }
            this.assignData();
            this.bannerlist = [res.landingPageDetail.bannerList[0]];
          } else {
            this.utils.hideLoading();
            this.utils.backToRoot();
            this.utils.openSnackBar(res.message, 'error-toster');
          }
        },
        error: (err: any) => {
          this.utils.hideLoading()
          if (err == 500) {
            this.utils.backToRoot();
          }
        }
      }))
    }
    else {
      this.utils.backToRoot();
    }
  }
  ngAfterViewInit() {
    this.imgLoaded = true;
  }
  @HostListener('window:scroll')
  onWindowScroll() {
    this.updateAutoplay();
  }

  updateAutoplay() {
    const isBannerVisible = this.utils.isElementVisible('caraousel-scroll');
    if (!isBannerVisible) {
      this.autoplay = false;
    } else {
      this.autoplay = true;
    }
  }



  triggerBannerClick(bannerData: any) {
    this._dataLayerService.triggerPromotionEvents(bannerData, 'select_promotion');
  }


  triggerPromotionEventsIfListExists(bannerList: any) {
    if (bannerList && bannerList.length > 0) {
      this._dataLayerService.triggerPromotionEvents(bannerList, 'view_promotion');
    }
  }


  assignData() {
    if (this.subcatData.landingPageDetail && this.subcatData.landingPageDetail.bannerList && this.subcatData.landingPageDetail.bannerList.length) {
      this.mobileBannerList = [];
      this.webBannerList = [];
      this.subcatData.landingPageDetail.bannerList.forEach((element: any) => {
        let mobileBanner = {
          image: element.mobileImageFile,
          link: element.ctaLink,
          altTag: element.altTag,
          guidId: element.guidId,
          isSmallBanner: element.isSmallBanner,
          filename: element.mobileImageFileName
        }
        let webBanner = {
          image: element.webImageFile,
          link: element.ctaLink,
          altTag: element.altTag,
          guidId: element.guidId,
          isSmallBanner: element.isSmallBanner,
          filename: element.webImageFileName
        }
        if (!element.isSmallBanner) {
          this.webBannerList.push(webBanner);
          this.mobileBannerList.push(mobileBanner);
        }
        else {
          this.smallWebBannerList.push(webBanner);
          this.smallMobileBannerList.push(mobileBanner);
        }

      });
      if (this.webBannerList && this.webBannerList.length > 1) {
        this.utils.customOptionsForBanner.loop = true;
      }
      if (this.smallWebBannerList && this.smallWebBannerList.length > 1) {
        this.utils.customOptionsForSmallBanner.loop = true;
      }
    }
    if (this.subcatData && this.subcatData.landingPageDetail) {
      this.schemaService.sendData(this.subcatData.landingPageDetail.brandSubCategoryName);

    }
    // this.getSubCategorySchema();
    if (this.subcatData.commonSectionDetail != "" && this.subcatData.commonSectionDetail != null && this.subcatData.commonSectionDetail != undefined) {
      this.faqlist = this.subcatData.commonSectionDetail.questionAnswerList;
    }
    this.productCarousalData = [];
    if (this.subcatData && this.subcatData.featuredProducts) {
      this.subcatData.featuredProducts.forEach((element: any) => {
        let obj = {
          image: element.productImage,
          description: element.productName,
          price: element.price ? element.price : '0',
          altTag: element.featureImageAltTag,
          productGuid: element.productGuid
        }
        this.productCarousalData.push(obj);
      });
    }
    if (this.subcatData && this.subcatData.technologyAttributeMappingDetails && this.subcatData.technologyAttributeMappingDetails && this.subcatData.technologyAttributeMappingDetails.technologyAttributeMapping.length) {
      this.selectedTechnologyData = this.subcatData.technologyAttributeMappingDetails.technologyAttributeMapping[0];
    }
    setTimeout(() => {
      let indexToRemove: any = []
      if (this.subcatData.commonSectionDetail && this.subcatData.commonSectionDetail.mediaList && this.subcatData.commonSectionDetail.mediaList.length) {
        this.subcatData.commonSectionDetail.mediaList.forEach((element: any, index: any) => {
          if (!this.utils.validURL(element.embededLink)) {
            indexToRemove.push(index);
          }
        });
      }
      if (indexToRemove && indexToRemove.length) {
        indexToRemove = indexToRemove.sort(function (a: any, b: any) { return b - a });
        indexToRemove.forEach((element: any) => {
          if (this.subcatData.commonSectionDetail && this.subcatData.commonSectionDetail != null && this.subcatData.commonSectionDetail != undefined) {
            this.subcatData.commonSectionDetail.mediaList.splice(element, 1);
          }
        });
      }
      if (this.subcatData.commonSectionDetail && this.subcatData.commonSectionDetail != null && this.subcatData.commonSectionDetail != undefined) {
        this.showVideoSection = this.subcatData && this.subcatData.commonSectionDetail && this.subcatData.commonSectionDetail.mediaList && this.subcatData.commonSectionDetail.mediaList.length ? true : false;
      }
    }, 200);

    this.utils.hideLoading();
    if (!this.isSchemaAdded()) {
      this.callSchema();
    }
  }
  private isSchemaAdded(): boolean {
    // Check if schema is present in the document
    const existingSchema = this._document.querySelector('script[type="application/ld+json"]');
    return !!existingSchema; // Returns true if schema is present, false otherwise
  }

  async callSchema() {
    try {
      // Generate breadcrumb schema
      const breadcrumbSchema = this.schemaService.addBreadcrumbSchema();

      // Generate item list schema
      const itemlistSchema = this.schemaService.addItemlistSchema();

      // Debug: Log FAQ list to ensure it contains data

      // Generate FAQ schema if `faqlist` is available
      if (this.faqlist?.length) {
        const faqSchema = this.schemaService.generateFaqJsonLd(this.faqlist);

        // Append FAQ schema script
        this.appendJsonLdScript(faqSchema);
      } else {
        console.warn('No FAQs found. Skipping FAQ JSON-LD script generation.');
      }

      // Debug: Log video list to ensure it contains data

      // Generate and append video schema if `medialist` contains data
      if (this.medialist?.length) {
        const videoSchema = this.schemaService.addVideoSchema(this.medialist);

        // Append video schema script
        this.appendJsonLdScript(videoSchema);
      } else {
        console.warn('No media found. Skipping Video JSON-LD script generation.');
      }

      // Append breadcrumb schema script
      this.appendJsonLdScript(breadcrumbSchema);

      // Append item list schema script
      this.appendJsonLdScript(itemlistSchema);

      // Optional: Log schemas for debugging    
    } catch (error) {
      console.error('Error in callSchema:', error);
    }
  }


  private appendJsonLdScript(schema: any) {
    if (!schema) {
      console.warn('Empty schema provided to appendJsonLdScript.');
      return;
    }

    // Create and append JSON-LD script
    const script = this._renderer2.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema, null, 2);
    this.script.defer = true;
    this._renderer2.appendChild(this._document.body, script);
  }

  resetAll() {
    this.subcatData = [];
    this.webBannerList = [];
    this.mobileBannerList = [];
    this.selectedTechnologyData = [];
    this.productCarousalData = [];
    this.smallWebBannerList = [];
    this.smallMobileBannerList = [];
    this.showVideoSection = false;
  }

  getSeriesRouteLink(seriesData: any) {
    let seriesTitle = this.utils.createNameForUrl(seriesData.seriesName);
    return `/series/${seriesTitle}`
  }

  triggerSeriesClicked(seriesData: any) {
    this.sub.add(this.utils.menuList.subscribe((data: any) => {
      data.forEach((catData: any) => {
        let obj: any = {};
        let selectedSubCat = catData.brandSubCategoriesMenus.filter((subCatData: any) => {
          if (this.utils.createNameForUrl(subCatData.subCategory) == this.landingPageName) {
            return subCatData
          }
        })
        if (selectedSubCat[0] && selectedSubCat[0].guid) {
          obj['guid'] = catData.guid;
          obj['landingPageGuid'] = catData.landingPageGuid;
          obj['category'] = catData.category;
          obj['categoryType'] = catData.categoryType;
          obj['brandSubCategoriesMenus'] = selectedSubCat[0];
          this.categoryData = obj;
        }
      });
    }))
    const data = {
      eventName: "Series Page Viewed",
      eventData: {
        'Series Name': seriesData.seriesName,
        'Sub-Category Name': this.subcatData.landingPageDetail.brandSubCategoryName || 'Sub Category',
        'Category Name': this.categoryData.category
      }
    };
    this.analyticsService.trackData(data);
  }

  getPlpRouteLink(seriesData: any) {
    let url = '';
    let catName: any = '';
    this.sub.add(this.utils.menuList.subscribe((data: any) => {
      for (const catData of data) {
        if (catName) {
          break;
        }
        for (const subCat of catData.brandSubCategoriesMenus) {
          if (subCat.guid == this.subcatData.landingPageDetail.brandSubCategoryGuid) {
            catName = this.utils.createNameForUrl(catData.category)
            break;
          }
        }
      }
    }))
    if (seriesData) {
      // url = `/product-listing/${this.utils.createNameForUrl(this.subcatData.landingPageDetail.brandSubCategoryName)}/${this.utils.createNameForUrl(seriesData.seriesName)}/${this.subcatData.landingPageDetail.brandSubCategoryGuid}/${seriesData.seriesGuid}`;
      url = `/product-listing/${catName}/${this.utils.createNameForUrl(this.subcatData.landingPageDetail.brandSubCategoryName)}/${this.utils.createNameForUrl(seriesData.seriesName)}`;
    }
    else {
      //url = `/product-listing/${catName}/${this.utils.createNameForUrl(this.subcatData.landingPageDetail.brandSubCategoryName)}/${this.subcatData.landingPageDetail.brandSubCategoryGuid}`;
      url = `/product-listing/${catName}/${this.utils.createNameForUrl(this.subcatData.landingPageDetail.brandSubCategoryName)}`;
    }
    return url;
  }

  onProductClick(_data: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('source', 'Brand');
    }
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.sub.unsubscribe()
  }
  // getSubCategorySchema(){
  //   let productListschemaarr:any = [];
  //   this.subcatData.subCategorySeriesAttributeMappings.forEach((ele:any,index) => {
  //     let tempObj = {
  //       "@type": "ListItem",
  //       "position": index + 1,
  //       "name": ele.seriesName,
  //       "url": `https://www.luminousindia.com/`
  //     }
  //     productListschemaarr.push(tempObj)
  //   })
  //   let schemaobj = {
  //     "@context": "https://schema.org/",
  //     "@type": "ItemList",
  //     "itemListElement":productListschemaarr
  //   }

  //   this.structuredData = this.sanitizer.bypassSecurityTrustHtml(`
  //     <script type="application/ld+json">
  //       ${JSON.stringify(schemaobj)}
  //     </script>
  //   `);
  //   }
}
